// src/components/Banner/index.tsx
import React, { useEffect, useState } from 'react'
import { GeneralSetting } from '@apis/index'
import { useSelector } from 'react-redux'
import { BannerContainer, BannerDot, BannerDots, BannerImage } from './style'
import BannerLoader from './loader/bannerLoading'

interface BannerProps {
  group: 'topBanner' | 'bottomBanner'
  type: 'Header' | 'Footer'
}

export const Banner: React.FC<BannerProps> = ({ group, type }) => {
  const [currentImage, setCurrentImage] = useState(0)
  const [leavingImage, setLeavingImage] = useState<number | null>(null)

  const fetchBanners = async () => {
    try {
      await GeneralSetting.getByGroup(group, 'banner-list', type)
    } catch (error) {
      console.error(`Failed to fetch ${group} banners:`, error)
    }
  }

  const { data, loading } = useSelector((state: any) => state[group])

  const bannerImages = Array.isArray(data)
    ? data.map((item: any) => `${process.env.BUCKET_URL}/${item.file}`)
    : []

  const homepageBanners = bannerImages?.length ? bannerImages : []

  useEffect(() => {
    if (!data?.length) fetchBanners()
  }, [])

  useEffect(() => {
    if (homepageBanners.length <= 1) return

    const interval = setInterval(() => {
      setLeavingImage(currentImage)
      setCurrentImage((prev) => (prev + 1) % homepageBanners.length)
    }, 5000)

    // Clear leaving image after animation
    const timeoutId = setTimeout(() => {
      setLeavingImage(null)
    }, 500)

    return () => {
      clearInterval(interval)
      clearTimeout(timeoutId)
    }
  }, [homepageBanners])

  return (
    <BannerContainer>
      {loading ? (
        <BannerLoader />
      ) : (
        <>
          {homepageBanners.map((src, index) => (
            <BannerImage
              key={src}
              src={src}
              isActive={index === currentImage}
              isLeaving={index === leavingImage}
              alt={`Banner ${index + 1}`}
            />
          ))}

          {homepageBanners.length > 1 && (
            <BannerDots>
              {homepageBanners.map((_, index) => (
                <BannerDot
                  key={index}
                  active={index === currentImage}
                  onClick={() => setCurrentImage(index)}
                />
              ))}
            </BannerDots>
          )}
        </>
      )}
    </BannerContainer>
  )
}

// Top and Bottom Banner components
export const TopBanner = () => <Banner group="topBanner" type="Header" />
export const BottomBanner = () => <Banner group="bottomBanner" type="Footer" />

export default Banner
